//Apollo
import ApolloClient from 'apollo-client';
import {InMemoryCache} from 'apollo-cache-inmemory';

import {createUploadLink} from 'apollo-upload-client';
import {urls, urlsCrm} from '../config/keys';

const linkKey = createUploadLink({uri: urls.graph, credentials: 'include'});
const linkCrm = createUploadLink({uri: urlsCrm.graph, credentials: 'include'});

const defaultOptions = {
   watchQuery: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'ignore'
   },
   query: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'all'
   }
};

export const clientLog = new ApolloClient({
   cache: new InMemoryCache(),
   link: linkCrm,
   defaultOptions: defaultOptions
});

export const clientApp = new ApolloClient({
   cache: new InMemoryCache(),
   link: linkKey,
   defaultOptions: defaultOptions
});
